import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '../../base.component';

@Component({
	selector: 'app-kickout-mfh-carrier-box',
	templateUrl: './kickout-mfh-carrier-box.component.html',
	styleUrls: ['./kickout-mfh-carrier-box.component.scss'],
})
export class KickoutMfhCarrierBoxComponent extends BaseComponent implements OnInit {
	constructor(injector: Injector) {
		super(injector);
	}

	ngOnInit() {}

	onClick() {}
}
